// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-dialog-div {\n  background-color: var(--v-white-base) !important;\n  color: var(--v-black-base) !important;\n  position: relative;\n  border-radius: 4px !important;\n}\n.confirm-dialog-div .close-x {\n  position: relative;\n  float: right;\n  right: 8px;\n  top: 8px;\n  height: 40px;\n  width: 40px;\n}", ""]);
// Exports
module.exports = exports;
